/**
 * The moving background.
 *
 * This exists as a component rather than more body:: pseudo-elements for one
 * structural reason: the grid has to MOVE while its fade mask STAYS PUT. If
 * you transform the same element the mask lives on, the fade travels with the
 * grid and the whole page looks like it is sliding off. So the mask goes on a
 * fixed container and the motion goes on a child inside it.
 *
 * Everything here animates transform and opacity only, which the compositor
 * handles on the GPU without repainting a single pixel of the page above it.
 * Animating background-position instead — the obvious way to drift a grid —
 * repaints a full-viewport layer every frame, and on a phone that is a
 * measurable battery cost for a decoration.
 *
 * It is also aria-hidden and honours prefers-reduced-motion, where it stops
 * dead. Constant background motion is a genuine accessibility problem for
 * people with vestibular disorders, not a preference.
 */
export default function Atmosphere() {
  return (
    <div className="atmo" aria-hidden="true">
      <div className="atmo-grid" />
      <div className="atmo-scan" />
      <div className="atmo-scan atmo-scan-b" />
      <div className="atmo-pulse" />
    </div>
  )
}
